class UserManagementPageDataSetter {

    searchUser(originalTableData, searchText) {

        return originalTableData.filter((item) => {
          searchText = searchText.toLowerCase().toString();
          let userId = !!item.userId;
          let userRole = !!item.userRole;
          let firstName = !!item.firstName;
          let middleName = !!item.middleName;
          let lastName = !!item.lastName;
          let emailAddress = !!item.emailAddress;
          let countryCode = !!item.countryCode;
          let phoneNumber = !!item.phoneNumber;
          let updatedDate = !!item.updatedDate;
          
    
    
          return (
            (userId ? item.userId.toLowerCase().includes(searchText) : false) ||
            (userRole ? item.userRole.toLowerCase().includes(searchText) : false) ||
            (firstName ? item.firstName.toString().includes(searchText) : false)||
            (middleName ? item.middleName.toString().includes(searchText) : false) ||
            (lastName ? item.lastName.toString().includes(searchText) : false) ||
            (emailAddress ? item.emailAddress.toString().toLowerCase().includes(searchText) : false) ||
            (countryCode ? item.countryCode.toString().toLowerCase().includes(searchText) : false) ||
            (phoneNumber ? item.phoneNumber.toString().toLowerCase().includes(searchText) : false) ||
            (updatedDate ? item.updatedDate.toString().includes(searchText) : false)
          );
        });
      }

      searchGrandparent(originalTableData, searchText) {

        return originalTableData.filter((item) => {
          searchText = searchText.toLowerCase().toString();
          let grandParentAccountId = !!item.grandParentAccountId;
          let grandParentAccountName = !!item.grandParentAccountName;
          let ownedBy = !!item.ownedBy;
          let createdBy = !!item.createdBy;
          let createdDate = !!item.createdDate;
          let updatedBy = !!item.updatedBy;
          let updatedDate = !!item.updatedDate;
         
          
    
    
          return (
            (grandParentAccountId ? item.grandParentAccountId.toString().toLowerCase().includes(searchText) : false) ||
            (grandParentAccountName ? item.grandParentAccountName.toLowerCase().includes(searchText) : false) ||
            (ownedBy ? item.ownedBy.toString().includes(searchText) : false)||
            (createdBy ? item.createdBy.toString().includes(searchText) : false) ||
            (createdDate ? item.createdDate.toString().includes(searchText) : false) ||
            (updatedBy ? item.updatedBy.toString().toLowerCase().includes(searchText) : false) ||
            (updatedDate ? item.updatedDate.toString().toLowerCase().includes(searchText) : false)
          );
        });
      }

}
 export default UserManagementPageDataSetter;